module.exports = __webpack_public_path__ + "static/media/hydropurr-logo.292d5efa.jpg";